import React from "react";
import {ProjectName, PROJECT_NAME} from "modules";
import {useMatch} from "react-router";
import {HyundaiBanner} from "./HyundaiBanner";
import {MatchPredictorBanner} from "./MatchPredictorBanner";
import {WhoAmIBanner} from "./WhoAmIBanner";

export const TopBanner: React.FC = () => {
	const isMatchPage = useMatch("/match");
	const isLeaderboardPage = useMatch("/rankings");

	if (PROJECT_NAME === ProjectName.WhoAmI && isLeaderboardPage) {
		return <WhoAmIBanner />;
	}

	if (PROJECT_NAME === ProjectName.HyundaiQuiz) {
		return <HyundaiBanner />;
	}

	if (PROJECT_NAME === ProjectName.Gott) {
		return <HyundaiBanner />;
	}

	if (PROJECT_NAME === ProjectName.MatchPredictor) {
		const className = isMatchPage ? "desktop" : "";
		return <MatchPredictorBanner className={className} />;
	}

	return null;
};

export * from "./MatchPredictorBanner";
